export * from './IconWideScreenFilled';
